import React, {useEffect, useState} from "react";
import "../../../Dashboard/Sidebar";
import ReactPaginate from 'react-paginate';
import Header from "../../../layout/header";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import NotFoundData from '../../../../Images/no-data-found.webp'
import Moment from "moment";

const BAOpportunityList = (
    {
        list,
        opportunityList = [],
        match,
        history
    }
) => {
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = useState(false);
    useEffect(() => {

        (async () => {
            setIsLoading(true)
            await list(0, 1, [{}], match?.params?.lead_id)
            setIsLoading(false)
        })()
    }, [])

    const onPageChange = async (val) => {
        await list('', val?.selected+1, [{}], match?.params?.lead_id)
    };

    return (
        <>
            <Loader isLoading={isLoading}/>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                       <Header
                          title={'Opportunity List'}
                          history={history}
                        />
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <div className="row col-md-12">
                                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                    {/* <form className="form-inline mr-auto w-90 navbar-search">
                                     <div className="d-flex">
                                        <input type="text" className="form-control bg-light border-0 small list-filter"
                                                placeholder="Search Opportunity..." aria-label="Search"
                                                aria-describedby="basic-addon2"
                                               onChange={(e) => {}}
                                        />
                                        <div className="btn-search">
                                            <button className="btn btn-primary lh-32 border-left-tr-tb" type="button">
                                                <i className="fas fa-search fa-sm"></i>
                                            </button>
                                        </div>
                                     </div>
                                    </form> */}
                                        <h1 className="h3 mb-0 text-black-100 w-90-d fnt-4">Total Opportunities : {(opportunityList && opportunityList?.data !== undefined && opportunityList?.data.length > 0) ?
                                            opportunityList?.data.length : 0}</h1>
                                    </div>
                                </div>
                            </div>
                            {/* Filter View */}
                            {/*    {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&*/}
                            {/*        <div className="d-sm-flex align-items-center justify-content-between mb-4">*/}
                            {/*            <div className="row pd-filter-div">*/}
                            {/*                <div className="col-md-12 col-sm-12 d-flex">*/}
                            {/*                    <div className="applied-filter">*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    }*/}
                             {/* Filter View End*/}
                                <div className="row mt-20px">
                                    {/*CARD START*/}

                                    {opportunityList && opportunityList?.data !== undefined && opportunityList?.data.length > 0 && opportunityList?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow card-padding">
                                                        <div className="card card-just-text" data-background="color"
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category">
                                                                {/*<div className="header-ui-item-opp">*/}
                                                                {/*    Called 3 times*/}
                                                                {/*</div>*/}
                                                                    <div className="row">
                                                                        <div className="col-10" style={{color:"#000", fontSize:"20px",textAlign:"left",paddingLeft:"20px"}}>
                                                                           <span className="">{val?.opportunity_name}</span>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            {/*TOGGLE*/}
                                                                            <div className="dropdown"
                                                                                 style={{"float": "right"}}>
                                                                                <a
                                                                                    href={`view-opportunity/${val?.id}`}
                                                                                    className="btn btn-sm icon-btn"
                                                                                    type="button"
                                                                                >
                                                                                    <i
                                                                                        className="fa fa-eye"
                                                                                        aria-hidden="true"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row list-view">
                                                                        {val?.details[0] !== undefined && val?.details[0]?.lead_status !== undefined && val?.details[0]?.lead_status !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-building"></i>&nbsp;&nbsp;Lead Status
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.details[0]?.lead_status}>
                                                                                        {val?.details[0]?.lead_status}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Created
                                                                                By
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.name}</div>
                                                                        </div>

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Created Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.created_at).format('DD-MM-YYYY')}</div>
                                                                        </div>
                                                                    </div>
                                                                    {(val?.details[0]?.lead_status !== "Closed - Won" && val?.details[0]?.lead_status !== "Closed - Dropped") &&
                                                                        <>
                                                                            <hr />
                                                                            <div className="row list-view-links">
                                                                                <ul>
                                                                                    <li></li>
                                                                                    <li><a
                                                                                        href={`edit-opportunity/${val?.id}`}>
                                                                                        <i className="bi bi-list"></i>&nbsp;&nbsp;Edit</a>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </h6>
                                                                <div className="col-sm-6">
                                                                    <a href={`/save-opportunity/${match?.params?.lead_id}`}
                                                                       className="draft-float">
                                                                        <p className="my-float" style={{marginTop: "20px"}}><i
                                                                            className="fa fa-plus"
                                                                            aria-hidden="true"></i></p>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {opportunityList && opportunityList?.data !== undefined && opportunityList?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(opportunityList?.total/opportunityList?.per_page)}
                                                forcePage={opportunityList?.current_page-1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {opportunityList  && opportunityList?.data !== undefined &&  opportunityList?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width":"100%"}}>
                                                Data Not Found
                                            </div>
                                            <div className="col-sm-6">
                                                <a href={`/save-opportunity/${match?.params?.lead_id}`}
                                                   className="draft-float">
                                                    <p className="my-float" style={{marginTop: "20px"}}><i
                                                        className="fa fa-plus"
                                                        aria-hidden="true"></i></p>
                                                </a>
                                            </div>
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section ends */}
        </>
    )
}

export default BAOpportunityList